import React, { Component, Fragment, useState, useEffect,useRef  } from 'react';
import { addField } from 'ra-core';
import Map from './map';
import { getMarkers, getPosition } from './utils';
import * as Constants from '../constants'
import CircularProgress from '@material-ui/core/CircularProgress';
import { useListContext, useGetList,useListParams, NumberInput, useDataProvider} from 'react-admin';

function useRecursiveTimeout(callback, delay) { 
    const savedCallback = useRef(callback)

    useEffect(() => {
      savedCallback.current = callback  
    }, [callback])

    useEffect(() => { 
      let id    
      function tick() {
        const ret = savedCallback.current()

        if (ret instanceof Promise) {
          ret.then(() => {
            if (delay !== null) {
              id = setTimeout(tick, delay)
            }
          })
        } else {
          if (delay !== null) {
            id = setTimeout(tick, delay)
          }
        }
      }
      if (delay !== null) {
        id = setTimeout(tick, delay)
        return () => id && clearTimeout(id)
      }
    }, [delay])
  }

export const GMapGrid = ({location}) => {
    //const { data, ids, total, loading, loaded, error, refetch } = useGetList("locations_map");
    //const [listParams, listParamsActions] = useListParams({
           //   resource: 'locations_map',
         //     location: location // From react-router. Injected to your component by react-admin inside a List
        // });
    const { filterValues, page, perPage, sort } = useListContext();
    const dataProvider = useDataProvider();
   
    const childrenProps = {
        groundOverlayOpacity: 1,
        loadingElement: <div style={{ height: '100%' }} />,
        containerElement: <div style={{ height: '80vh' }} />,
        googleMapURL: `https://maps.googleapis.com/maps/api/js?key=AIzaSyCTF0Xc4Q_2Kt85EVdtE_1dsJ3vTCanjUs&v=3.exp&libraries=geometry,drawing,places`,
        
      };
    const [center, setCenter] = useState({ lat: 31.880012, lng: 35.01361 });
    const [zoom, setZoom] = useState(15);
    const [image, setImage] = useState( "");
    const [bounds, setBounds] = useState([]);
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const [markers, setMarkers] = useState({})
    const markersColors = ["#0000FF","#FF3300","#FFFF00","#006600","#000000","#CC6600","#9933FF","#5F5F5F","#00FFFF","#99CC00","#D5DE60","#000099","#F97045","#CCCC00","#008080","#009A5C","#B2B2B2","#00FF99","#FF9900","#00FF00","#666699","#0099FF","#990000","#FF0066","#993300"];
    const loadOverlayFromRecords = (records, trackFilter) => {
        if (!records || !records.length) {
            return;
        }

        // Prefer an activity that matches the current track filter (Course Name),
        // otherwise fall back to the first record.
        let overlayRecord = null;
        if (trackFilter != null) {
            for (let i = 0; i < records.length; i++) {
                const r = records[i];
                if (r && r.track === trackFilter) {
                    overlayRecord = r;
                    break;
                }
            }
        }
        if (!overlayRecord) {
            overlayRecord = records[0];
        }
        if (!overlayRecord || !overlayRecord.image_bounds) {
            return;
        }

        const bounds = overlayRecord.image_bounds;
        setImage(overlayRecord.image);
        setBounds(bounds);
        setCenter({lat: bounds[0][0], lng: bounds[0][1]});
        const img = new Image();
        img.src = overlayRecord.image;
        img.onload = () => {
            setIsImageLoaded(true);
        }
    };

    const getMarkers = () =>{
        const trackFilter = filterValues && filterValues.track ? filterValues.track : null;

        const pagination = {
            page: page || 1,
            perPage: perPage || 1000,
        };
        const sortParams = sort || { field: 'id', order: 'ASC' };
        const filters = filterValues || {};

        return dataProvider
            .getList('locations_map', {
                pagination,
                sort: sortParams,
                filter: filters,
            })
            .then(({ data: records }) => {
                if (!records || !records.length) {
                    setMarkers([]);
                    return;
                }

                // Ensure overlay is loaded / updated
                if (!isImageLoaded) {
                    loadOverlayFromRecords(records, trackFilter);
                } else {
                    const firstRecord = records[0];
                    if (firstRecord && firstRecord.image && image !== firstRecord.image) {
                        const baseImage = image.split('?')[0];
                        const baseNewImage = firstRecord.image.split('?')[0];
                        if (baseImage !== baseNewImage) {
                            setIsImageLoaded(false);
                            loadOverlayFromRecords(records, trackFilter);
                        }
                    }
                }

                const baseTrackId =
                    trackFilter != null
                        ? trackFilter
                        : (records[0] ? records[0].track : null);

                let nextMarkers = [];
                for (let i = 0; i < records.length; i++) {
                    const record = records[i];
                    // When a specific Course Name is selected, only show markers for that track.
                    // If no track filter is applied, show markers for all activities.
                    if (baseTrackId !== null && trackFilter != null && record && record.track !== baseTrackId) {
                        continue;
                    }
                    if (record && record.last_location && record.last_location.lat) {
                        nextMarkers = [
                            ...nextMarkers,
                            {
                                lat: parseFloat(record.last_location.lat),
                                lng: parseFloat(record.last_location.lng),
                                label: record.short_name,
                                color: markersColors[i % 25],
                            },
                        ];
                    }
                }
                setMarkers(nextMarkers);
            })
            .catch(error => {
                console.error('Failed to fetch locations for map', error);
            });
    }

    // Periodically refresh locations using the dataProvider without forcing the
    // react-admin List to remount, so the map zoom/viewport stays intact.
    useRecursiveTimeout(getMarkers, 5000);

    return (
      <Fragment>
        <div style={{ position: 'relative' }}>
          {
            image === "" ?
            <span></span> :
            isImageLoaded ?
          <Map
            mapElement={<div style={{ height: '100%' }} />}
            center={center}
            image={image}
            bounds={bounds}
            onMapClick={e => {}}
            onMarkerClick={e => {}}
            defaultZoom={zoom}
            markers= {markers}
            {...childrenProps}
          /> : 
          <div style={{textAlign: "center", alignItems: "center"}}>
            <CircularProgress />
          </div>
  }
        </div>
      </Fragment>
    );
  }